import React from 'react';

interface FormInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel' | 'number';
  required?: boolean;
}

export default function FormInput({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  required = false
}: FormInputProps) {
  return (
    <div>
      <label htmlFor={id} className="block text-supporting font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-error-red">*</span>}
      </label>
      <input
        type={type}
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-3 border border-border-light rounded-md text-body-lg focus:ring-2 focus:ring-trust-blue/20 focus:border-trust-blue transition-all duration-200 font-inter"
        required={required}
      />
    </div>
  );
}